/**
 * "I started a game."
 *
 * One short beacon to the site the page came from, saying which map. No
 * name, no address in the body - the server hashes where it came from,
 * the way it does a visit - and nothing else ever, so that the promise in
 * server/journal.ts stays nearly whole: the page sends one thing, and it
 * is the thing a crawler cannot send, because a crawler presses nothing.
 * "Роби друге, а ще відфільтруй ботів."
 *
 * Sent with sendBeacon so a page that is reloading into a world - which
 * joining does - still gets it out. Never awaited, never retried: a game
 * that goes uncounted is a line missing from a table, not a game lost.
 */
export function tellPlayed(map: string): void {
  try {
    const body = JSON.stringify({ map });
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon("/played", new Blob([body], { type: "application/json" }));
      return;
    }
    void fetch("/played", { method: "POST", body, keepalive: true }).catch(() => { /* uncounted */ });
  } catch { /* uncounted */ }
}
